
export const timezoneOptions = [
  { value: "Eastern Standard Time", label: "Eastern (EST/EDT)" },
  { value: "Central Standard Time", label: "Central (CST/CDT)" },
  { value: "Mountain Standard Time", label: "Mountain (MST/MDT)" },
  { value: "Pacific Standard Time", label: "Pacific (PST/PDT)" },
  { value: "Alaska Standard Time", label: "Alaska (AKST/AKDT)" },
  { value: "Hawaii Standard Time", label: "Hawaii (HST)" },
  { value: "Atlantic Standard Time", label: "Atlantic (AST/ADT)" },
  { value: "Arizona Standard Time", label: "Arizona" },
  { value: "Indiana East Standard Time", label: "Indiana (EST)" },
  { value: "Samoa Standard Time", label: "Samoa (SST)" },
  { value: "Chamorro Standard Time", label: "Chamorro (ChST) - Guam" },
  { value: "Puerto Rico and US Virgin Islands Time", label: "Puerto Rico & US Virgin Islands (AST)" }
];
